import React from 'react';
import Icon from '../Icon'

export default function ProAMIcon({ title, fontSize, color }) {
    return (<Icon icon="users-alt-4" title={title} style={{ color: (color)?color:"darkred", fontSize: (fontSize)?fontSize:"16px", paddingRight: (title!== undefined)?"4px":"0px" }} className="proam-icon"/>);
};